import { Component, OnInit, AfterContentInit } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { ModeloRdService } from 'src/app/services/modelo-rd.service';

@Component({
  selector: 'app-modelos-rd',
  templateUrl: './modelos-rd.component.html',
  styleUrls: ['./modelos-rd.component.sass']
})

export class ModelosRdComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];

  public form: FormGroup = null;
  public id = 0; // representa o id do modelo. Se 0 novo cadastro, Se > 0 editando
  public isProcessing = false;
  public isEditing = false;
  public voids: string[] = [];
  public maxRowsVoids = 7;
  public validaLayoutRpt: string = '';

  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private modeloRDService: ModeloRdService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,

  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('modelo-rd');
  }

  ngOnInit() {
    this.getAll(); // carrega lista de já cadastrados
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public getAll(): void {
    this.modeloRDService.getAll().subscribe((response: any) => {
      this.cadastrados = response;
      this.setVoids();
    });
  }

  public resetForm(): void {
    this.form = this.formBuilder.group(
      {
        id: [0],
        nome: [null, [Validators.required]],
        prefixo: [null, [Validators.required]],
        layoutRPT: [null, [Validators.required]]
      });

    this.isEditing = false;
    this.validaLayoutRpt = '';

  }

  public reset(): void {

    this.isProcessing = false;
    this.isEditing = false;
    this.resetForm();
  }

  public getById(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.modeloRDService.getById(id).subscribe(

      (response: any) => {

        this.form.patchValue({
          id: response.id,
          nome: response.nome,
          prefixo: response.prefixo,
          layoutRPT: response.layoutRpt
        });

        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.validaLayoutRpt = '';

    if (this.isInvalidLayoutRpt(this.form.get('layoutRPT').value)) {
      this.validaLayoutRpt = "Este campo não pode conter números, dígitos ou caracteres especiais";
      return;
    }

    this.isProcessing = true;

    if (this.form.get('id').value === 0) {
      this.modeloRDService.isUniqueNome(this.form.get('nome').value, this.form.get('id').value).subscribe(

        (isUniqueNome: boolean) => {

          if (isUniqueNome) {

            this.modeloRDService.isUniquePrefixo(this.form.get('prefixo').value, this.form.get('id').value).subscribe(
              (isUniquePrefixo: boolean) => {

                if (isUniquePrefixo) {
                  this.save();
                } else {
                  this.form.get('prefixo').setErrors({ isNotUniquePrefixo: true });
                  this.isProcessing = false;
                }
              },
              (error: any) => { this.showError(error); }
            );

          } else {
            this.form.get('nome').setErrors({ isNotUniqueNome: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
    } else {
      this.save();
    }

  }

  private save() {
    this.modeloRDService.add(this.form.value).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }


  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static' });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.modeloRDService.deleteById(id).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    this.form.get('nome').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }



  isInvalidLayoutRpt = (layoutRpt: string) => {

    let inValid = false;

    const chars = Array.from(layoutRpt);

    let hasCharCodeEspecial = false;
    let hasCharCodeDigit = false;
    let hasSpace = false;

    chars.forEach(s => {
      if (inValid === false) {
        hasCharCodeEspecial = hasCharCodeEspecial || (s.charCodeAt(0) >= 33 && s.charCodeAt(0) <= 47
          || s.charCodeAt(0) >= 58 && s.charCodeAt(0) <= 64);
        hasCharCodeDigit = hasCharCodeDigit || (s.charCodeAt(0) >= 48 && s.charCodeAt(0) <= 57);
        hasSpace = hasSpace || (s.charCodeAt(0) == 32);
        inValid = hasCharCodeEspecial || hasCharCodeDigit || hasSpace;
      }
    });
    return inValid;
  }

}



